<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Reporte Conflicto de Interés </legend>
          </div>
            <div class="row">
              <div class="col-md-6">
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_servidores" :items-per-page="5" class="" :search="filter" :fixed-header="true"  :custom-filter="buscaServ">
                  <template v-slot:item.nombres="{ item }">
                    <div>{{getNombre(item)}}</div>
                  </template>
                  <template v-slot:item.ente_publico_id="{ item }">
                    <div>{{getDependencias(item.ente_publico_id)}}</div>
                  </template>
                  <template v-slot:item.fecha="{ item }">
                    <div>{{ dateFormat(item.declaracion.Fecha_Dec) }}</div>
                  </template>
                  <template v-slot:item.tipo="{ item }">
                    <div>{{ item.declaracion.Tipo_Dec}}</div>
                  </template>
                </v-data-table>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PPagination from 'src/components/UIComponents/Pagination.vue'
import moment from 'moment'

export default {
      components: {
      PPagination
    },
    props: ["data"],
    data() {
        return{
            filter: null,
            list_servidores: [],
            headers: [{
                text: 'Nombre completo',
                value: 'nombres',
                align: 'left',
            }, {
                text: 'RFC',
                value: 'rfc',
                align: 'center',
            }, {
                text: 'Dependencia',
                value: 'ente_publico_id',
                align: 'left',
            },{
                text: 'Fecha de presentación de declaración',
                value: 'fecha',
                align: 'center',
            },{
                text: 'Tipo de declaración',
                value: 'tipo',
                align: 'left',
            }, ],
        }
    },
    methods: {
        buscaServ (value, search, item) {

      },
        getNombre(item) {
        var resp = (item.nombres ||'')+ " " + (item.primer_apellido ||'' )+ " " + (item.segundo_apellido||'');

        return resp;
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function(item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      dateFormat: function(date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
    },
    created() {
        this.$http.get("getConflictos").then(response => {

        this.list_servidores = response.data.usuarios;
        console.log(this.list_servidores)
        // this.filtro_usuarios = this.list_usuarios;

      }, error => {
        this.Err(error);
      });

      this.$http.get("cat_ente_publico").then(response => {
        this.dependencias = response.data.entes_publicos;
      }, error => {
        this.Err(error);
      });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/RepConflictoInteres.vue